import Api from '../api/Api';
import differenceInDays from 'date-fns/difference_in_days';
import resolve from  '../util/Configuracao';
import { parse } from 'date-fns';

class CarenciaApi extends Api {
  async consultar (beneficiario) {
    const { codServidor, codTipoMensalidade, seqBeneficiario, seqDependente, numSeqDependenteRH } = beneficiario;
    try {
      const url = resolve('urlCarenciaConsultar') +
        `/${codTipoMensalidade}` +
        `/${codServidor}` +
        `/${seqBeneficiario}` +
        `${numSeqDependenteRH !== null ? `?numSeqDependenteRH=${numSeqDependenteRH}` : ''}` +
        `${numSeqDependenteRH !== null ? `&seqDependente=${seqDependente}` : ''}`;
      const { data } = await this.fetch(url);
      let carencias = this._normalizaCarencias(data, beneficiario);
      return carencias;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarPorCarteira (numMatricula) {
    try {
      const url = resolve('urlCarenciaConsultarPorCarteira') + numMatricula;
      const { data } = await this.fetch(url);
      let carencias = data;
      return carencias;
    } catch (error) {
      console.error(error);
    }
  }

  async salvar (carencias) {
    const url = resolve('urlCarenciaSalvar');
    let response = {};
    for (var i = 0; i < carencias.length; i++) {
      carencias[i].dtaFimCarencia = parse(carencias[i].dtaFimCarencia);
      response = await this.fetch(url, 'POST', carencias[i], { 'content-type': 'application/json' });
    }
    return response;
  }
  _normalizaCarencias = (carencias, beneficiario) => {
    carencias.map(carencia => {
      carencia.dtaFimCarencia = carencia.dtaFimCarencia || beneficiario.dtaInicio;
      carencia.qtdeDiasDeCarencia = carencia.dtaFimCarencia === null ? 0 : differenceInDays(new Date(carencia.dtaFimCarencia), new Date(beneficiario.dtaInicio));
      const diasEntreDatas = differenceInDays(new Date(carencia.dtaFimCarencia), new Date());
      carencia.desCondicaoAdmissao = carencia.dtaFimCarencia === null ? 'O beneficiário já pode solicitar este tipo de procedimento.'
        : diasEntreDatas > 0
          ? 'O beneficiário só poderá solicitar este tipo de procedimento em ' + diasEntreDatas + ' dias.'
          : 'O beneficiário já pode solicitar este tipo de procedimento.';
    });
    return carencias;
  }
}

export default CarenciaApi;
